import React, { useRef, useEffect } from "react";
export default function AdminCasas(props) {
  const houses = useRef(null);
  useEffect(() => window.DMInstitutions.mountManagement(houses.current), []);
  return <div ref={houses} />;
}
export { AdminCasas };
